import React from 'react'
import ContentLoader from 'react-content-loader'

export class JobItemPlaceholer extends React.PureComponent {
	render() {
		return (
			<div className='job-item-placeholder'>
				<ContentLoader height={120} width={400}>
					<rect x='0' y='0' rx='5' ry='5' width='120' height='120' />
					<rect x='130' y='0' rx='4' ry='4' width='315' height='15' />
					<rect
						x='130'
						y='27'
						rx='3'
						ry='3'
						width='280'
						height='15'
					/>
					<rect
						x='130'
						y='55'
						rx='3'
						ry='3'
						width='250'
						height='15'
					/>
				</ContentLoader>
			</div>
		)
	}
}
